<template functional>
  <div>
    <el-tag
      type="warning"
      v-if="props.column === 'Aprobed' && props.row[props.column] === false"
    >
      No
    </el-tag>
    <el-tag
      type="success"
      v-if="props.column === 'Aprobed' && props.row[props.column] === true"
    >
      Si
    </el-tag>
    <el-tag
      type="info"
      v-if="props.column === 'Open' && props.row[props.column] === false"
    >
      No
    </el-tag>
    <el-tag
      type="primary"
      v-if="props.column === 'Open' && props.row[props.column] === true"
    >
      Si
    </el-tag>
  </div>
</template>

<script>
export default {
  name: "nominacolorBoolTag"
};
</script>

<style></style>
